import Mock from 'mockjs'

export function mockData(mockOpts: any) {
  // if (VAR.env === 'dev') {
  return { s: 200, data: Mock.mock(mockOpts), msg: '' }
  // }
  // throw { s: 870, msg: '非开发环境不能使用模拟数据' }
}

export const typeInt = (min: number, max: number) => `@integer(${min}, ${max})`

export const typeTitle = (min: number, max: number) => `@ctitle(${min}, ${max})`

export const tid = typeInt(100000, 999999)

export const title20 = typeTitle(1, 20)

export function dateRange(year?: number, month?: number, date?: number) {
  const end = arguments.length == 3 ? new Date(year!, month! - 1, date) : new Date()
  const start = new Date(end)
  start.setFullYear(end.getFullYear() - 1)
  return typeInt(start.getTime(), end.getTime())
}

export const imageList = [
  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/2/482153547.png',
  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/23/862834502.jpg',
  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/229/817780655.png',
  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/17/337919814.jpg',
  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/16/668145452.jpg',

  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/5/614865833.png',
  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/223/349975007.jpg',
  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/9/580077901.jpg',
  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/222/368911066.jpg',
  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/282/255881333.png',

  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/279/688603196.png',
  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/281/372107997.png',
  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/278/746022628.png',
  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/226/656527442.jpg',
  'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/236/452286055.jpg',
]
